module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.c62aeef3.ttf";